module.exports = __webpack_public_path__ + "static/media/report-hero.c64aeaa3.svg";